import { Input, Select, TextArea } from 'semantic-ui-react';
import { formInput, formSelectService, selectArea, textArea } from 'src/components/helpers';
import { RegistrationForm } from 'src/assets/styles/components/Registration';
import { NETWORK_CATEGORIES } from 'src/containers/comunidad-network/networkCategories';
import { yesNoValue } from 'src/containers/comunidad-network/form/networkFormUtils';

const NetworkFormBusinessSections = ({
  inputs,
  errorInputs,
  handleInputs,
  selectHandle,
  selectOnBlur = true,
}) => {
  const {
    businessName,
    category,
    serviceOffered,
    productDescription,
    facebook,
    instagram,
    businessPhone,
    twitter,
    leaderPhone,
    leaderName,
  } = inputs;

  return (
    <>
      <section className="form-section">
        <h3 className="form-section__title">Información adicional</h3>
        <div className="form-section__body">
          <RegistrationForm as="div" className="network-fields">
            <div className="field-grid">
              {formInput({
                Input,
                handler: handleInputs,
                label: 'Nombre del líder',
                name: 'leaderName',
                value: leaderName || '',
                errorInputs,
              })}
              {formInput({
                Input,
                handler: handleInputs,
                label: 'Teléfono del líder',
                type: 'number',
                name: 'leaderPhone',
                value: leaderPhone || '',
                errorInputs,
              })}
            </div>
          </RegistrationForm>
          <div className="comunidadMemeber">
            {selectArea({
              Select,
              options: ['Seleccione', 'Si', 'No'],
              label: '¿Se congrega en Comunidad MDE?',
              name: 'comunidadMemeber',
              value: yesNoValue(inputs.comunidadMemeber),
              errorInputs,
              handler: selectHandle,
              selectOnBlur,
            })}
          </div>
        </div>
      </section>

      <section className="form-section">
        <h3 className="form-section__title">Información de la empresa</h3>
        <div className="form-section__body">
          <RegistrationForm as="div" className="network-fields">
            <div className="field-grid field-grid--full">
              <div className="field-grid__full">
                {formInput({
                  errorInputs,
                  Input,
                  handler: handleInputs,
                  label: 'Nombre de la empresa',
                  name: 'businessName',
                  value: businessName || '',
                })}
              </div>
              <div className="field-grid__full">
                {formSelectService({
                  Select,
                  handler: selectHandle,
                  label: 'Categoría',
                  name: 'category',
                  value: category || '',
                  errorInputs,
                  options: NETWORK_CATEGORIES,
                  search: true,
                  selectOnBlur: false,
                })}
              </div>
              {formInput({
                errorInputs,
                Input,
                handler: handleInputs,
                type: 'number',
                label: 'Teléfono de la empresa',
                name: 'businessPhone',
                value: businessPhone || '',
              })}
              {formInput({
                errorInputs,
                Input,
                handler: handleInputs,
                label: 'Facebook',
                name: 'facebook',
                value: facebook || '',
              })}
              {formInput({
                errorInputs,
                Input,
                handler: handleInputs,
                label: 'Instagram',
                name: 'instagram',
                value: instagram || '',
              })}
              {formInput({
                errorInputs,
                Input,
                handler: handleInputs,
                label: 'Twitter',
                name: 'twitter',
                value: twitter || '',
              })}
            </div>
          </RegistrationForm>
        </div>
      </section>

      <section className="form-section">
        <h3 className="form-section__title">Información del producto o servicio</h3>
        <div className="form-section__body">
          <div className="product-fields">
            {formInput({
              errorInputs,
              Input,
              handler: handleInputs,
              label: 'Servicio o Producto que ofrece',
              name: 'serviceOffered',
              value: serviceOffered || '',
            })}
            {textArea({
              TextArea,
              label: 'Descripción o detalles de su producto o servicio.',
              name: 'productDescription',
              handler: handleInputs,
              value: productDescription || '',
              errorInputs,
              style: { maxWidth: '100%', minWidth: '100%', width: '100%' },
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default NetworkFormBusinessSections;
